import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../main/Auth/useAuth';

const ReviewRoute = () => {
    const auth = useAuth();
    if (!auth || !auth.user) {
        return <Navigate to="/login" replace />;
    }
    return (auth.user.level === 1 || String(auth.user.level) === '1') ? <Outlet /> : <Navigate to="/login" replace />;
}
export default ReviewRoute;
